module.exports = __webpack_public_path__ + "assets/img/ALERT.b2f1d7fb.svg";